'use client';

import { addLineBreakAfterHandleAnchors } from '@/components/summarizer/summaryTextUtils';
import { isRecord, toTrimmedNonEmptyString } from '@/lib/utils/type-guards';

export function resolveFriendlyErrorMessage(raw: unknown): string {
  if (!raw) {
    return 'Unable to summarize this conversation right now.';
  }
  if (typeof raw === 'string') {
    const trimmed = toTrimmedNonEmptyString(raw);
    if (!trimmed) {
      return 'Unable to summarize this conversation right now.';
    }
    if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
      try {
        return resolveFriendlyErrorMessage(JSON.parse(trimmed));
      } catch {
        // fall through to returning trimmed string below
      }
    }
    return trimmed;
  }
  if (isRecord<{ message?: unknown; code?: unknown; error?: unknown }>(raw)) {
    const { message: maybeMessage, code: maybeCode, error: maybeError } = raw;
    if (maybeCode === 'CONVERSATION_TOO_SMALL') {
      return 'Need at least six tweets or an external link before we can summarize this conversation.';
    }
    const trimmedError = toTrimmedNonEmptyString(maybeError);
    if (trimmedError) {
      return trimmedError;
    }
    const trimmedMessage = toTrimmedNonEmptyString(maybeMessage);
    if (trimmedMessage) {
      return trimmedMessage;
    }
  }
  return 'Unable to summarize this conversation right now.';
}

export function formatSummaryForDisplay(text: string): string {
  if (!text) {
    return '';
  }

  return addLineBreakAfterHandleAnchors(text);
}
